export var Role;
(function (Role) {
    Role["GENERAL"] = "general";
    Role["CORE"] = "core";
    Role["ADMIN"] = "admin";
})(Role || (Role = {}));
